  <template lang="pug">
    v-stepper(v-model="e1")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2") Pencegahan/Persyaratan Khusus

      v-stepper-items
        v-stepper-content(step="1")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Judul Lampiran
                v-flex(xs7 sm5)
                  v-text-field(class="inputDefault" v-model='judulLampiran' label="Judul Lampiran" @blur="checkNameValidity" :error="nameErrorToggle" :error-messages="errorMessage")
                v-flex(xs1 sm4)

                v-flex(xs3 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Hari & Tanggal
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="inspectionDate"
                        label="Hari & Tanggal"
                        prepend-icon="event"
                        readonly
                        v-on="on")
                    v-date-picker(v-model="inspectionDate" @input="clearDate" :min="todayDate")
                v-flex(xs1 sm5)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Departemen/Divisi
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                        class="inputDefault"
                        v-model="deptDivisi"
                        :items="dataUsers.department"
                        label="Department")
                    v-col
                      v-text-field(class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Perusahaan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="perusahaan"
                    :items="dataUsers.companies"
                    label="Perusahaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Supplier Unit
                v-flex(xs7 sm5)
                  v-text-field(class="inputDefault" v-model='supplierUnit' label="Supplier Unit")
                v-flex(xs1 sm4)
                
                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Jenis Kendaraan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="jenisKendaraan"
                    :items="carType"
                    item-text="name"
                    multiple
                    clearable
                    label="Jenis Kendaraan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Model Kendaraan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="modelKendaraan"
                    :items="carInfos"
                    multiple
                    clearable
                    label="Model Kendaraan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Nomor Kendaraan
                v-flex(xs7 sm5)
                  v-text-field(class="inputDefault" v-model='nomorKendaraan' label="Nomor Kendaraan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Nama Pengawas Lampiran
                v-flex(xs7 sm5)
                  v-menu(
                    v-model="searchPengetahuMenu"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="pengetahu.name"
                        label="Penyetuju Lampiran"
                        readonly
                        v-on="on")
                    PermitUserModal(:searchPermitUser="searchPengetahuMenu" @interface="searchPengetahuMenu = false" @selectedUser="updatePengetahuLampiran" :onlyName="true")
                v-flex(xs1 sm4)
          v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="2")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs12 sm12) 
                  h3(class="headerSection") ITEM YANG DIPERIKSA
                v-flex(xs5 sm7)
                  p(class="headerInput") Kondisi kursi menurut standar pabrik, terpasang dengan aman
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiKursi" label="Pilih" clearable)
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Klakson, intensitas suara cukup memadai
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiKlakson" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Wiper depan dan pembersih kaca berfungsi dengan baik
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiWiper" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Semua lampu berfungsi dengan baik (lampu depan, lampu belakang, lampu rem dan lampu sein)
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiLampu" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Safety bar / rolling bar
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiSafetyBar" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Kaca spion dalam kondisi baik
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiKacaSpion" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") APAR siap digunakan
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiApar" label="Pilih" clearable) 
              

                v-flex(xs12 sm12)
                    v-row 
                        v-col(cols="3")
                            h3(class="headerSection") REM, STEERING, SEAT BELT 
                        v-col(cols="8")
                            p(style="color: red;") (kegagalan fungsi pada item berikut, maka pengawalan ditunda untuk perbaikan terlebih dahulu)
                v-flex(xs5 sm7)
                  p(class="headerInput") Rem Kaki
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiRemKaki" label="Pilih" clearable)
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Rem Tangan
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiRemTangan" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Sistem Steering
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiSistemSteering" label="Pilih" clearable) 
              

                v-flex(xs5 sm7)
                  p(class="headerInput") Seat Belt
                v-flex(xs1 sm2)
                v-flex(xs5 sm3)
                    v-select(class="selectInput" :items='checkOptions' v-model="kondisiSeatBelt" label="Pilih" clearable) 
              

                v-flex(xs12 sm12)
                    v-row 
                        v-col(cols="4")
                            h3(class="headerSection") BAN DAN TRACK DALAM KONDISI NORMAL
                        v-col(cols="8")
                            p(style="color: blue;") (*Ban No.1 dimulai dari posisi bawah driver ke arah kiri Ban No.2, Ban No.3 di belakang driver dst)
                v-flex(xs5 sm9)
                  v-container(class="headerInput")
                    v-row 
                        v-col
                            AlteringCheckbox(label="BAN No.1" v-model="banStatus[0]['status']")
                            AlteringCheckbox(label="BAN No.2" v-model="banStatus[1]['status']")
                            AlteringCheckbox(label="BAN No.3" v-model="banStatus[2]['status']")
                            AlteringCheckbox(label="BAN No.4" v-model="banStatus[3]['status']")
                        v-col
                            AlteringCheckbox(label="BAN No.5" v-model="banStatus[4]['status']")
                            AlteringCheckbox(label="BAN No.6" v-model="banStatus[5]['status']")
                            AlteringCheckbox(label="BAN No.7" v-model="banStatus[6]['status']")
                            AlteringCheckbox(label="BAN No.8" v-model="banStatus[7]['status']")
                        v-col
                            AlteringCheckbox(label="BAN No.9" v-model="banStatus[8]['status']")
                            AlteringCheckbox(label="BAN No.10" v-model="banStatus[9]['status']")
                            AlteringCheckbox(label="BAN No.11" v-model="banStatus[10]['status']")
                            AlteringCheckbox(label="BAN No.12" v-model="banStatus[11]['status']")
                        v-col
                            AlteringCheckbox(label="BAN No.13" v-model="banStatus[12]['status']")
                            AlteringCheckbox(label="BAN No.14" v-model="banStatus[13]['status']")
                            AlteringCheckbox(label="BAN No.15" v-model="banStatus[14]['status']")
                            AlteringCheckbox(label="BAN No.16" v-model="banStatus[15]['status']")
                        v-col
                            AlteringCheckbox(label="BAN No.17" v-model="banStatus[16]['status']")
                            AlteringCheckbox(label="BAN No.18" v-model="banStatus[17]['status']")
                            AlteringCheckbox(label="BAN No.19" v-model="banStatus[18]['status']")
                            AlteringCheckbox(label="BAN No.20" v-model="banStatus[19]['status']")
                        
                v-flex(xs1 sm1)

                v-flex(xs5 sm3) 
                  h3(class="headerSection") Upload Dokumen
                v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                  v-file-input(:rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                    template(v-slot:selection="{ text }" )
                      v-chip(small label color="primary")   {{ text }}
                v-flex(xs6 sm5 class="attachmentName" v-if="docPendukung")
                  span {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                  v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                    v-icon mdi-close
                v-flex(xs1 sm4)

          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(class="mr-3" color='info' @click='submit(1);')
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          v-btn(v-if='!submitClick' color='success' @click='submit(2)')
            v-icon send
            | &nbsp; Submit Request
          v-btn(text @click="backHome()") Cancel
  </template>

  <script>
  import helper from "../helper/index.js";
  import axios from "axios";
  import { mapState } from "vuex";
  import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import PermitUserModal from "./PermitUserModal.vue";
  import CarModal from './CarModal.vue';
  import AlteringCheckbox from './AlteringCheckbox.vue';
  export default {
    name: "AddKetinggian",
    components: {
      AlteringCheckbox,
      PermitUserModal,
      CarModal,
    },
    props: {
      edit: { type: Boolean, default: false },
      users: Array
    },
    data() {
      return {
        e1: 1,
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [ MyCustomUploadAdapterPlugin ],
          removePlugins : ['ImageUpload','MediaEmbed'],
          toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
          image: {
            // You need to configure the image toolbar, too, so it uses the new style buttons.
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
            styles: [
                // This option is equal to a situation where no style is applied.
                'full',
                // This represents an image aligned to the left.
                'alignLeft',
                // This represents an image aligned to the right.
                'alignRight'
            ]
          }
        },

        // Step 1
        judulLampiran: '',
        currentName: '',
        isNameValid: false,
        nameErrorToggle: false,
        errorMessage: "",
        inspectionDate: '',
        perusahaan: '',
        supplierUnit: '',
        jenisKendaraan: [],
        modelKendaraan: [],
        nomorKendaraan: '',
        deptDivisi: '',
        divisi: '',

        pengetahu: '',

        searchCarMenu: false,
        selectedCars: [],
        // -- End of step 1


        // Step 2
        kondisiKursi: '',

        kondisiKlakson: '',

        kondisiWiper: '',

        kondisiLampu: '',

        kondisiSafetyBar: '',

        kondisiKacaSpion: '',
        
        kondisiApar: '',

        kondisiRemKaki: '',

        kondisiRemTangan: '',

        kondisiSistemSteering: '',

        kondisiSeatBelt: '',

        status: 0,

        banStatus: [
          {
            banNo: 1,
            status: null
          },
          {
            banNo: 2,
            status: null
          },
          {
            banNo: 3,
            status: null
          },
          {
            banNo: 4,
            status: null
          },
          {
            banNo: 5,
            status: null
          },
          {
            banNo: 6,
            status: null
          },
          {
            banNo: 7,
            status: null
          },
          {
            banNo: 8,
            status: null
          },
          {
            banNo: 9,
            status: null
          },
          {
            banNo: 10,
            status: null
          },
          {
            banNo: 11,
            status: null
          },
          {
            banNo: 12,
            status: null
          },
          {
            banNo: 13,
            status: null
          },
          {
            banNo: 14,
            status: null
          },
          {
            banNo: 15,
            status: null
          },
          {
            banNo: 16,
            status: null
          },
          {
            banNo: 17,
            status: null
          },
          {
            banNo: 18,
            status: null
          },
          {
            banNo: 19,
            status: null
          },
          {
            banNo: 20,
            status: null
          },
        ],
        // -- End of step 2



        todayDate: new Date().toISOString().slice(0,10),
        lokasi: '',

        searchPemegangMenu: false,
        searchPengetahuMenu: false,
        startMenu: false,
        endMenu: false,
        startDateExtend: new Date().toISOString().substr(0, 10),
        endDateExtend: new Date().toISOString().substr(0, 10),
        startMenuExtend: false,
        endMenuExtend: false,

        checkOptions: ['Baik', 'Rusak'],

        uploadId: null,
        docPendukung: null,
        submitClick: false,
        rules: [
          value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
        ],
        emptyUpload: new File([""], "", {
          type: "",
        })
      };
    },
    mounted: async function() {
      this.$store.dispatch("fetchCarType");
      this.$store.dispatch("fetchCarInfos");
      this.uploadId = Date.now();
      if(this.edit) {
        await this.checkNameValidity();
      }
    },
    computed: {
      ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest", "carType", 'carInfos']),
      isPage1Complete: function() {
        return this.isNameValid && this.divisi && this.deptDivisi && this.perusahaan && this.supplierUnit && this.jenisKendaraan.length > 0 && this.modelKendaraan.length > 0 && this.nomorKendaraan && this.inspectionDate && this.pengetahu;
      }
    },
    methods: {
      async checkNameValidity() {
        const result = await axios.post(`${this.API_URL}/form/lampiranNameValidity`, { lampiranName: this.judulLampiran });
        let isValid = result.data.valid;
        if(this.edit) {
          isValid = this.judulLampiran == this.currentName;
        }
        
        this.isNameValid = isValid;
        this.nameErrorToggle = !isValid;
        this.errorMessage = !isValid ? "Title already exists in the database!" : '';
      },
      updatePengajuLampiran(user) {
        this.pengaju = user;
      },
      updatePengetahuLampiran(user) {
        this.pengetahu = user;
      },
      clearDate(){
        this.startMenu = false;
      },
      formatDate:helper.formatDate,
      scrollTop(){
        window.scrollTo(0,0);
      },
      submit(status){
        this.submitClick = true;
        this.status = status;

        let formData = new FormData();
        if (this.edit) {
          formData.append('_id', this.dataEditRequest._id);
          formData.append('ipNo', this.dataEditRequest.ipNo);
          formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
        }
        formData.append('ipTitle', this.judulLampiran);
        formData.append('ipInspectionDate', this.inspectionDate );
        formData.append('ipPerusahaan', this.perusahaan );
        formData.append('ipSupplierUnit', this.supplierUnit);
        formData.append('ipJenisKendaraan', this.jenisKendaraan);
        formData.append('ipModelKendaraan', this.modelKendaraan);
        formData.append('ipNomorKendaraan', this.nomorKendaraan);
        formData.append('ipStatus', this.status);
        formData.append('ipDeptDivisi', this.deptDivisi);
        formData.append('ipDivisi', this.divisi);
        formData.append('ipPengetahu', JSON.stringify(this.pengetahu));
        formData.append('ipLocation', JSON.stringify(this.dataUsers.location));
        formData.append('ipSelectedCars', JSON.stringify(this.selectedCars));
        // Step 2
        formData.append('ipKondisiKursi', this.kondisiKursi || 'N/A');

        formData.append('ipKondisiKlakson', this.kondisiKlakson || 'N/A');
        
        formData.append('ipKondisiWiper', this.kondisiWiper || 'N/A');
        
        formData.append('ipKondisiLampu', this.kondisiLampu || 'N/A');
        
        formData.append('ipKondisiSafetyBar', this.kondisiSafetyBar || 'N/A');
        
        formData.append('ipKondisiKacaSpion', this.kondisiKacaSpion || 'N/A');
        
        formData.append('ipKondisiApar', this.kondisiApar || 'N/A');
        
        formData.append('ipKondisiRemKaki', this.kondisiRemKaki || 'N/A');
        
        formData.append('ipKondisiRemTangan', this.kondisiRemTangan || 'N/A');
        
        formData.append('ipKondisiSistemSteering', this.kondisiSistemSteering || 'N/A');
        
        formData.append('ipKondisiSeatBelt', this.kondisiSeatBelt || 'N/A');

        formData.append('ipBanStatus', JSON.stringify(this.banStatus));

        // -- End of Step 2

        formData.append('uploadId', this.uploadId );
        formData.append('ipUser', JSON.stringify(this.dataUsers) );

        const config = {
          method: this.edit ? "put" : "post",
          url: `${this.API_URL}/v1/requests/submitAttachment`,
          headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
          data: formData
        };
        axios(config).then(res => {
          this.$store.commit("temporaryData", res);
          this.$router.push("/my-attachment");
        });
      },
      // upload(name, paramFile){
      //   if(paramFile == undefined) return ;
      //   if(paramFile.size > 10000000){
      //     paramFile = null;
      //     if(name == 'docPendukung'){
      //       this.docPendukung = this.emptyUpload;
      //     }
      //     return
      //   }else{
      //     let formData = new FormData();
      //     formData.append('uploadId', this.uploadId );
      //     formData.append(name, paramFile );
      //     axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      //   }      
      // },
      deleteDocPendukung(name){
        let id = this.uploadId.toString();      
        this.$store
          .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
          })
          .then(() => {
            this.docPendukung = null;
          })
          .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
          });
      },
      backHome(){
        this.$router.push("/my-attachment");
      },
      backStep(){
        this.e1--
      },
      docName(name){
        return this.$setFilename(name);
      }
    },
    watch: {
      docPendukung(params){
        // console.log("firing")
        if(params && params.size < 10000000){
          let formData = new FormData();
          formData.append('uploadId', this.uploadId );
          formData.append('docPendukung', params );
          axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
        }
    },
      dataEditRequest: async function() {
        // for (const item of this.locations) {
        //   let checked = false
        //   for (const element of this.dataEditRequest.ipLocation) {
        //     if(item.name == element.name) checked = true
        //   } 
        //   if(checked) this.lokasi.push(true)
        //   else this.lokasi.push(false)
        // }

        this.judulLampiran = this.dataEditRequest.ipTitle;
        this.currentName = this.dataEditRequest.ipTitle;
        this.inspectionDate = this.formatDate(this.dataEditRequest.ipInspectionDate).slice(0,10);
        this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
        this.divisi = this.dataEditRequest.ipDivisi;
        this.perusahaan = this.dataEditRequest.ipPerusahaan;
        this.supplierUnit = this.dataEditRequest.ipSupplierUnit;
        this.jenisKendaraan = this.dataEditRequest.ipJenisKendaraan.split(',');
        this.modelKendaraan = this.dataEditRequest.ipModelKendaraan.split(',');
        this.nomorKendaraan = this.dataEditRequest.ipNomorKendaraan;
        this.pengaju = this.dataEditRequest.ipPengaju;
        this.pengetahu = this.dataEditRequest.ipPengetahu;
        this.selectedCars = this.dataEditRequest.ipSelectedCars;

        this.kondisiKursi = this.dataEditRequest.ipKondisiKursi;

        this.kondisiKlakson = this.dataEditRequest.ipKondisiKlakson;

        this.kondisiWiper = this.dataEditRequest.ipKondisiWiper;

        this.kondisiLampu = this.dataEditRequest.ipKondisiLampu;

        this.kondisiSafetyBar = this.dataEditRequest.ipKondisiSafetyBar;

        this.kondisiKacaSpion = this.dataEditRequest.ipKondisiKacaSpion;

        this.kondisiApar = this.dataEditRequest.ipKondisiApar;

        this.kondisiRemKaki = this.dataEditRequest.ipKondisiRemKaki;

        this.kondisiRemTangan = this.dataEditRequest.ipKondisiRemTangan;

        this.kondisiSistemSteering = this.dataEditRequest.ipKondisiSistemSteering;

        this.kondisiSeatBelt = this.dataEditRequest.ipKondisiSeatBelt;

        this.banStatus = this.dataEditRequest.ipBanStatus;

        this.uploadId = this.dataEditRequest.uploadId;
        this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
      },
    }
  };
  </script>

  <style>
  .ck-editor__editable {
      min-height: 300px;
      max-height: 300px;
      resize:none;
  }
  .mustFill {
    color: #EA5164;
  }
  .alteringCheckbox {
    width: 24px;
    height: 24px;
    outline: 1px;
    outline-style: solid;
    outline-color: black;
    min-height: 24px !important;
    min-width: 24px !important;
  }
  </style>
